import React, { useEffect, useState } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { Table } from 'rsuite'
import { useHistory } from 'react-router-dom'
import { ReactComponent as SvgDownload } from '../../../../assets/svg/download.svg'
import LoaderComponent from '../../../CommonComponents/LoaderComponent'
import { getChildSuppliersWithMasterIds, getLocationBasedMasterSuppliers, getMasterSuppliers, getMasterSuppliersByUserCount } from '../../../../redux/actions/vendor'
import MergeMastersModal from '../../modals/mergeMasterModalComponent/merge-masters-modal'
import { toast } from '../../../CommonComponents/ToastComponent/toast'
import { getAbbreviatedState } from '../../../../services/helper'
import { Link } from "react-router-dom"

const { Column, HeaderCell, Cell, Pagination } = Table

export const LinkCell = ({ rowData, dataKey, onClick, currentTab, isLoading = false, ...props }) => {
  let bgColorClass = rowData[dataKey] === 'In Calls' ? 'bg-blue' : rowData[dataKey] === 'Approved' ? 'bg-green' : rowData[dataKey] === 'Rejected' ? 'bg-red' : 'bg-yellow'
  let stateCode = ''

  if (dataKey === 'state') {
    if (rowData?.abbreviatedState === null) {
      stateCode = getAbbreviatedState(rowData?.abbreviatedState, rowData?.state)
    } else {
      stateCode = rowData?.abbreviatedState
    }
  }

  return (
    <Cell {...props} className="table-link">
      {dataKey === 'state' ?
        stateCode
        :
        dataKey === 'supplierQARole' ?
          <h5 style={{ width: '60px' }} className={`btn text-white ${bgColorClass}`}>
            {rowData[dataKey]}
          </h5>
          :
          <button className='text-primary' type="button" disabled={dataKey === 'suppliername' && isLoading} onClick={() => onClick(dataKey === 'primaryMasterSupplierName' ? rowData.masterId : rowData.id, (currentTab === 'location' && dataKey === 'primaryMasterSupplierName') ? 'master' : currentTab)}>
            {rowData[dataKey]}
          </button>
      }
    </Cell>
  )
}

export const SelectorCell = ({ rowData, dataKey, onChange, selectedMasterIds, onSelectMaster, onShowChildren, isLoading, ...props }) => {
  const isSelected = selectedMasterIds && selectedMasterIds.length > 0 ? selectedMasterIds.findIndex(id => id === rowData.id) !== -1 : false
  return (
    <Cell {...props} className="table-action" fixed>
      <div className="button container">
        {
          isSelected ? (
            <button disabled={isLoading} type="button" className="btn btn-green select w-auto h-100" onClick={() => onSelectMaster(rowData.id)}>DE SELECT</button>
          ) : (
            <button disabled={isLoading} type="button" className="btn btn-green select w-auto h-100" onClick={() => onSelectMaster(rowData.id)}>SELECT</button>
          )
        }
        <button disabled={isLoading} type="button" className="btn btn-gray children" onClick={() => onShowChildren(rowData.id)}>SHOW CHILDREN</button>
      </div>
    </Cell>
  )
}

const MasterRecordComponent = ({ onShowExportModal, tableData, masterSuppliers, selectedMasterIds, onGoToMasterDetail, onSelectMaster, onSelectChildren, totalMasterRecords, searchList, selectedChildrens, locationSearchList, locationMasterTableData, totalLocationMasterRecords }) => {
  const history = useHistory()
  useEffect(() => {
    history.push('/suppliers')
  }, [])
  const store = useStore().getState()
  const dispatch = useDispatch()
  const {
    app: { masterSupplierTableColumns, childSupplierColumns: locationBasedSupplierColumns },
    vendor: { isLoadingMasterSupplier, isLoadingLocationMasterSupplier, suppliersSearchResults, suppliersSearchList }
  } = store

  const [sortColumn, setSortColumn] = useState('id')
  const [sortType, setSortType] = useState('asc')
  const [limit, setLimit] = React.useState(10)
  const [page, setPage] = React.useState(1)
  const [paginatedTableData, setPaginatedTableData] = useState([])
  const [totalTableRecords, setTableTotalRecords] = useState(0)
  const [showMergeMastersModal, setShowMergeMastersModal] = useState(false)
  const [selectedMastersData, setSelectedMastersData] = useState([])
  const [currentTab, setCurrentTab] = useState('master')
  const [tableColumns, setTableColumns] = useState([])
  const [isChildrenFiltered, setIsChildrenFiltered] = useState(false)

  useEffect(() => {
    if (selectedMasterIds.length === 0) {
      setSelectedMastersData([])
    }
  }, [selectedMasterIds])

  useEffect(() => {
    if (suppliersSearchList?.searchTarget && suppliersSearchList?.searchTarget?.value === 'locationMaster') {
      setCurrentTab('location')
      setTableTotalRecords(suppliersSearchResults?.locationMasters?.total || 0)
      setPaginatedTableData(suppliersSearchResults?.locationMasters?.data || [])
    }
    if (suppliersSearchList?.searchTarget && suppliersSearchList?.searchTarget?.value === 'master') {
      setCurrentTab('master')
      setTableTotalRecords(suppliersSearchResults?.masters?.total || 0)
      setPaginatedTableData(suppliersSearchResults?.masters?.data || [])
    }
  }, [suppliersSearchList, suppliersSearchResults])

  useEffect(() => {
    if (!(tableData && tableData.length > 0)) {
      return
    }
    setTableTotalRecords(totalMasterRecords)
    setPaginatedTableData(tableData)
    setCurrentTab('master')
    setTableColumns(masterSupplierTableColumns)
  }, [tableData])

  useEffect(() => {
    setPage(1)
    setTableTotalRecords(totalMasterRecords)
    setPaginatedTableData(tableData)
  }, [totalMasterRecords])//[searchList, searchTarget]

  useEffect(() => {
    if (currentTab === 'location') {
      if (!(locationMasterTableData && locationMasterTableData.length > 0)) {
        return
      }
      setTableTotalRecords(totalLocationMasterRecords)
      setPaginatedTableData(locationMasterTableData)
    }
  }, [locationMasterTableData])

  useEffect(() => {
    if (currentTab === 'location') {
      setPage(1)
      setTableTotalRecords(totalLocationMasterRecords)
      setPaginatedTableData(tableData)
    }
  }, [totalLocationMasterRecords])

  const handleChangeLimit = dataKey => {
    setPage(1);
    setLimit(dataKey);
    if (currentTab === 'master') {
      dispatch(getMasterSuppliers({
        limit: dataKey,
        offset: 0,
        searchList,
        sortColumn,
        sortType
      })).then(res => {
        // setPaginatedTableData(res)
        setPaginatedTableData(res?.masterSuppliers)
        setTableTotalRecords(res?.totalMasters || 0)
        setTableColumns(masterSupplierTableColumns)
      })
    } else {
      let locMasterColumns = [...masterSupplierTableColumns]
      locMasterColumns.splice(1, 0, {
        name: 'primaryMasterSupplierName',
        label: 'Primary Master Supplier Name',
      })
      setTableColumns(locMasterColumns)
      dispatch(getLocationBasedMasterSuppliers({
        limit: dataKey,
        offset: 0,
        searchList: locationSearchList,
        sortColumn,
        sortType
      })).then(res => {
        setPaginatedTableData(res?.locationMasters)
        setTableTotalRecords(res?.totalLocationMasters || 0)
      })
    }
  }

  const handleChangePage = (event) => {
    setPage(event)
    if (currentTab === 'master') {
      dispatch(getMasterSuppliers({
        limit: limit,
        offset: limit * (event - 1),
        searchList,
        sortColumn,
        sortType
      })).then(res => {
        setPaginatedTableData(res?.masterSuppliers)
        setTableTotalRecords(res?.totalMasters || 0)
        setTableColumns(masterSupplierTableColumns)
      })
    } else {
      let locMasterColumns = [...masterSupplierTableColumns]
      locMasterColumns.splice(1, 0, {
        name: 'primaryMasterSupplierName',
        label: 'Primary Master Supplier Name',
      })
      setTableColumns(locMasterColumns)
      dispatch(getLocationBasedMasterSuppliers({
        limit: limit,
        offset: limit * (event - 1),
        searchList: locationSearchList,
        sortColumn,
        sortType
      })).then(res => {
        setPaginatedTableData(res?.locationMasters)
        setTableTotalRecords(res?.totalLocationMasters || 0)
      })
    }
  }

  const onSubmit = () => {
    if (selectedMasterIds.length >= 2) {
      setShowMergeMastersModal(true)
    } else {
      toast.show({
        title: 'Warning',
        description: 'Please select atleast two master to merge!',
      })
    }
  }

  const onDownload = (tableData) => {
    const exportData = [masterSupplierTableColumns.map(column => {
      if (column.name === 'relatedSuppliersCount') {
        return 'Total Related Suppliers'
      } else {
        return column.label
      }
    })]
    exportData.push(...tableData.map(row => {
      return masterSupplierTableColumns.map(column => row[column.name])
    }))
    onShowExportModal(exportData, 'master_supplier')
  }

  const handleShowChildren = async (masterId) => {
    if (masterId || (selectedMasterIds && selectedMasterIds?.length)) {
      setIsChildrenFiltered(true)
    }
    if (!selectedMasterIds || selectedMasterIds.length === 0) {
      onSelectChildren([masterId])
      return
    }
    onSelectChildren(selectedMasterIds)
  }

  const handleShowAllChild = () => {
    onSelectChildren([])
  }

  const handleSelectMaster = (id) => {
    const isExisted = selectedMastersData.findIndex(masterData => masterData?.id === id)
    onSelectMaster(id)
    if (isExisted !== -1) {
      setSelectedMastersData([...selectedMastersData.filter(masterData => masterData?.id !== id)])
    } else {
      const data = paginatedTableData?.find(sup => sup?.id === id)
      setSelectedMastersData([...selectedMastersData, data])
    }
  }

  const handleClickMaster = (masterId, type = "master") => {
    onGoToMasterDetail(masterId, type)
  }

  const handleSortTableData = (sortColumn, sortType) => {
    setSortColumn(sortColumn)
    setSortType(sortType)
    if (currentTab === 'master') {
      dispatch(getMasterSuppliers({
        limit: limit,
        offset: limit * (page - 1),
        searchList,
        sortColumn,
        sortType
      })).then(res => {
        setPaginatedTableData(res?.masterSuppliers)
        setTableTotalRecords(res?.totalMasters || 0)
        setTableColumns(masterSupplierTableColumns)
      })
    } else {
      let locMasterColumns = [...masterSupplierTableColumns]
      locMasterColumns.splice(1, 0, {
        name: 'primaryMasterSupplierName',
        label: 'Primary Master Supplier Name',
      })
      setTableColumns(locMasterColumns)
      dispatch(getLocationBasedMasterSuppliers({
        limit: limit,
        offset: limit * (page - 1),
        searchList: locationSearchList,
        sortColumn,
        sortType
      })).then(res => {
        setPaginatedTableData(res?.locationMasters)
        setTableTotalRecords(res?.totalLocationMasters || 0)
      })
    }
  }

  const headerElement = tableColumns.map((h, index) => {
    const sortableColumns = ['suppliername', 'address1', 'address2', 'city', 'state', 'zip', 'employerIdNumber']
    const isSortable = sortableColumns?.includes(h.name)
    if (index === 0) {
      return (
        <Column
          resizable
          sortable={isSortable}
          key={h.name}
        >
          <HeaderCell>{currentTab === 'location' ? 'Supplier Name' : h.label}</HeaderCell>
          <LinkCell dataKey={h.name} isLoading={currentTab === 'master' ? isLoadingMasterSupplier : isLoadingLocationMasterSupplier} onClick={handleClickMaster} currentTab={currentTab} />
        </Column>
      )
    }

    if (h.name === "primaryMasterSupplierName") {
      return (
        <Column
          resizable
          sortable={isSortable}
          key={h.name}
        >
          <HeaderCell>{h.label}</HeaderCell>
          <LinkCell dataKey={h.name} isLoading={currentTab === 'master' ? isLoadingMasterSupplier : isLoadingLocationMasterSupplier} onClick={handleClickMaster} currentTab={currentTab} />
        </Column>
      )
    }

    return (
      <Column
        resizable
        sortable={isSortable}
        key={h.name}
      >
        <HeaderCell>{h.label}</HeaderCell>
        {h.name === 'state' ?
          <LinkCell dataKey={h.name} currentTab={currentTab} />
          :
          <Cell dataKey={h.name} />
        }
      </Column>
    )
  })

  const handleCloseExportModal = (closeMergeMasterModal = false) => {
    setShowMergeMastersModal(false)
    onSelectMaster()
    setSelectedMastersData([])
    if (closeMergeMasterModal) {
      setPage(1);
      setLimit(10);
      if (currentTab === 'master') {
        dispatch(getMasterSuppliers({
          limit: 10,
          offset: 0,
          searchList,
          sortColumn,
          sortType
        })).then(async (res) => {
          setPaginatedTableData(res?.masterSuppliers)
          setTableTotalRecords(res?.totalMasters || 0)
        })
      } else {
        let locMasterColumns = masterSupplierTableColumns?.map(col => col) // [...masterSupplierTableColumns]
        locMasterColumns.splice(1, 0, {
          name: 'primaryMasterSupplierName',
          label: 'Master Supplier Name'
        })
        setTableColumns(locMasterColumns)
        dispatch(getLocationBasedMasterSuppliers({
          limit: limit,
          offset: 0,
          searchList: locationSearchList,
          sortColumn,
          sortType
        })).then(res => {
          setPaginatedTableData(res?.locationMasters)
          setTableTotalRecords(res?.totalLocationMasters || 0)
        })
      }
    }
  }

  const handleClickTab = (tab) => {
    if (tab === currentTab) {
      return
    }

    setLimit(limit)
    setPage(1)
    onSelectMaster()
    setSelectedMastersData([])
    setIsChildrenFiltered(false)

    if (tab === 'master') {
      if (suppliersSearchList?.master && Object.keys(suppliersSearchList?.master)?.length > 0) {
        setPaginatedTableData(suppliersSearchResults?.masters?.data || [])
        setTableTotalRecords(suppliersSearchResults?.masters?.total || 0)
        setTableColumns(masterSupplierTableColumns)
      } else {
        dispatch(getMasterSuppliers({
          limit: limit,
          offset: 0,
          searchList,
          sortColumn,
          sortType
        })).then(res => {
          setPaginatedTableData(res?.masterSuppliers)
          setTableTotalRecords(res?.totalMasters || 0)
          setTableColumns(masterSupplierTableColumns)
        })
      }
    } else {
      let locMasterColumns = masterSupplierTableColumns?.map(col => col) // [...masterSupplierTableColumns]
      locMasterColumns.splice(1, 0, {
        name: 'primaryMasterSupplierName',
        label: 'Master Supplier Name'
      })
      setTableColumns(locMasterColumns)
      if (suppliersSearchList?.locationMaster && Object.keys(suppliersSearchList?.locationMaster)?.length > 0) {
        setPaginatedTableData(suppliersSearchResults?.locationMasters?.data || [])
        setTableTotalRecords(suppliersSearchResults?.locationMasters?.total || 0)
      } else {
        dispatch(getLocationBasedMasterSuppliers({
          limit: limit,
          offset: 0,
          searchList: locationSearchList,
          sortColumn,
          sortType
        })).then(res => {
          setPaginatedTableData(res?.locationMasters)
          setTableTotalRecords(res?.totalLocationMasters || 0)
        })
      }
    }
    setCurrentTab(tab)
  }
  
  return (
    <>
      <div className={`record-container master-record`}>
        <div className="record-header flex flex-wrap justify-space-between align-center ">
          <div className="record-title">
            <div className="page-tabs gap-4 gap-md-5 ">
              {
                <>
                  <button
                    className={`page-tab me-0${currentTab === 'master' ? ' selected' : ''}`}
                    onClick={() => { handleClickTab('master') }}
                  >
                    Master Supplier
                  </button>

                  <button
                    className={`page-tab me-0${currentTab === 'location' ? ' selected' : ''}`}
                    onClick={() => { handleClickTab('location') }}
                  >
                    Location Based Master
                  </button>
                </>
              }
            </div>
          </div>
          <div className="record-toolbar flex flex-wrap align-center">
            <div className="toolbar-item select">
            </div>
            <div className="toolbar-item flex-wrap gap-2">
              <button className="ms-0 btn-submit h-auto p-3" onClick={handleShowAllChild}>SHOW ALL CHILD SUPPLIERS</button>
              <button className="btn-submit h-auto p-3 ms-0" onClick={onSubmit}>{currentTab === 'master' ? 'MERGE MASTER RECORDS' : 'MERGE LOCATION BASED MASTERS'} </button>
              <button className="btn-download h-auto p-3 ms-0" onClick={() => onDownload(tableData)}><SvgDownload /></button>
            </div>
          </div>
        </div>
        <div className={`record-body position-relative${(currentTab === 'master' ? isLoadingMasterSupplier : isLoadingLocationMasterSupplier) ? ' loading' : ''}`}>
          {(currentTab === 'master' ? isLoadingMasterSupplier : isLoadingLocationMasterSupplier) && <LoaderComponent />}
          <Table
            virtualized
            autoHeight
            affixHeader={true}
            data={paginatedTableData}
            sortColumn={sortColumn}
            sortType={sortType}
            onSortColumn={handleSortTableData}
          >
            <Column
              resizable
              key='supplierQARole'
            >
              <HeaderCell>QA Status</HeaderCell>
              <LinkCell dataKey='supplierQARole' />
            </Column>

            {headerElement}

            <Column
              width={250}
              fixed="right"
              key="action"
            >
              <HeaderCell>Action</HeaderCell>
              <SelectorCell
                isLoading={isLoadingMasterSupplier}
                onShowChildren={handleShowChildren}
                onSelectMaster={handleSelectMaster}
                selectedMasterIds={selectedMasterIds}
              />
            </Column>
          </Table>
          <div className="pagination">
            <Pagination
              prev
              next
              first
              last
              showInfo
              maxButtons={5}
              lengthMenu={[
                {
                  label: '5',
                  value: 5,
                },
                {
                  label: '10',
                  value: 10,
                },
                {
                  label: '25',
                  value: 25,
                },
                {
                  label: '50',
                  value: 50,
                },
              ]}
              displayLength={limit}
              total={totalTableRecords}
              limit={limit}
              activePage={page}
              onChangePage={(event) => { handleChangePage(event) }}
              onChangeLength={handleChangeLimit}
            />
          </div>
        </div>
      </div>
      {showMergeMastersModal &&
        <MergeMastersModal
          show={showMergeMastersModal}
          onClose={handleCloseExportModal}
          selectedMasterIds={selectedMasterIds}
          masterSuppliersData={selectedMastersData}
        />
      }
    </>
  )
}
export default MasterRecordComponent